import { useCognitoAuth } from '@/contexts/cognitoAuthContext'
import { useGetAccountInfo } from '@/queries/account/useGetAccountInfo'
import { usePremiumFeaturesStore } from '@/stores/permissions/premiumFeatures'
import { useEffect } from 'react'

/**
 * Hydrates the premium features store with `accountType` from the
 * `/accounts/:id` endpoint. `billing.EnforceBillingFoundations` needs to target by account type now.
 */
export function useAccountInfoFetcher() {
  const { accountId } = useCognitoAuth()
  const { data } = useGetAccountInfo({ accountId })
  const { actions } = usePremiumFeaturesStore()

  useEffect(() => {
    // Reset accountType whenever there is no accountId (logged out) or while
    // data for a freshly selected accountId is still loading.
    if (!accountId || !data) {
      actions.setAccountType(null)
      return
    }
    actions.setAccountType(data.accountType ?? null)
  }, [actions, accountId, data])
}
